module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._t("default", function() {
    return [_c('v-btn', {
      class: _vm.classes,
      attrs: {
        "icon": "",
        "small": _vm.small,
        "attrs": _vm.attrs,
        "disabled": !_vm.number,
        "href": _vm.whatsappIt(_vm.number, _vm.message),
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.noop.apply(null, arguments)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": _vm.small,
        "color": "success"
      }
    }, [_vm._v("whatsapp")])], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf9a8f64","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/WhatsAppBtn.vue
// module id = 1524
// module chunks = 9